<template>
    <div style="width: 100vw; height: 100vh; background-color: #efefef; display: flex; justify-content: center; align-items: center">
        <div style="width: 350px; height: 600px; background-color: #fff; padding: 20px; display: flex; flex-direction: column">
            <div style="display: flex; align-items: center">
                <img style="width: 50px; border-radius: 100px" :src="user.headimgurl" />
                <div style="margin-left: 10px">{{ user.nickname }}</div>
            </div>
            <h1 style="margin-top: 10px">选择登录帐号</h1>
            <div v-if="user.accounts">
                当前登录方式有
                <span style="color: green">{{ user.accounts.length }}</span>
                个关联帐号，请选择登录帐号
            </div>
            <Input placeholder="输入名字或用户搜索" v-model="search" />
            <div style="margin-top: 20px">主帐号</div>
            <div style="flex: 1; min-height: 0; overflow-y: scroll">
                <div
                    @click="activeIndex = index"
                    v-for="(item, index) in cpList"
                    :style="`margin-bottom: 10px; background-color: ${index == activeIndex ? '#ecf2fe' : '#f2f4f8'};color: ${
                        index == activeIndex ? '#2773e0' : '#000'
                    }; padding: 10px; cursor: pointer`"
                >
                    <div style="display: flex; justify-content: space-between">
                        <div>{{ item.name }}</div>
                        <!--<div style="padding: 3px; background-color: #d4e3fc; color: #3853af">上次登录</div>-->
                    </div>
                    <div>帐号ID:{{ item.user }}</div>
                </div>
            </div>
            <div
                @click="continiu"
                style="
                    padding: 10px 20px;
                    background-color: #2352d9;
                    color: #fff;
                    cursor: pointer;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                "
            >
                <div>继续</div>
                <Icon type="md-arrow-forward" />
            </div>
        </div>
    </div>
</template>
<script>
import { GetUserTempToken, SelectLogin } from '@/request/api.js';
export default {
    name: 'select_account',
    data() {
        return {
            code: '',
            state: '',
            user: '',
            activeIndex: 0,
            search: '',
        };
    },
    computed: {
        cpList() {
            try {
                let data = this.user.accounts.filter((item1) => item1.name.indexOf(this.search) != -1 || item1.user.indexOf(this.search) != -1);
                return data;
            } catch (e) {
                /* handle error */
                return [];
            }
        },
    },
    mounted() {
        let query = this.$route.query;
        this.code = query.code;
        this.state = query.state;
        //非开发环境去掉URL参数不要刷新页面
        if (window.location.hostname != 'localhost') {
            window.history.replaceState({}, document.title, window.location.pathname);
        }
        setTimeout(() => {
            this.login();
        }, 1000);
    },
    methods: {
        async login() {
            let res = await GetUserTempToken({
                authCode: this.code,
                statusCode: this.state,
            });
            if (res.errcode == 0) {
                this.user = res.data;
            }
        },
        async continiu() {
            let { data: res } = await SelectLogin({
                token: this.user.token,
                userId: this.user.accounts[this.activeIndex].uid,
                statusCode: this.user.statusCode,
            });
            localStorage.setItem('isBindOpenId', res.data.isBindOpenId);
            if (res.data.cms_token) {
                localStorage.setItem('cms_token', res.data.cms_token); //设置令牌
                localStorage.setItem('username', res.data.user); //设置账号名
                this.$Message.success('登录成功!');
                localStorage.setItem('type', res.data.type); //设置用户级别
                this.$router.push('/select_stores?type=' + res.data.type);
                return;
            }
        },
    },
};
</script>
